// extracted by mini-css-extract-plugin
export var attribution = "_ch-4";
export var authorName = "_ch-5";
export var quote = "_ch-3";
export var testimonial = "_ch-2";
export var trustedBy = "_ch-0";
export var trustedByLabel = "_ch-1";